// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ApkManager.css */

/* ==================================================== */
/* 1. Modal Container and Main Card Structure */
/* ==================================================== */

.main-content-card {
    background-color: #ffffff;
    padding: 30px; 
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15); 
}

.list-title {
    color: #333;
    margin-top: 0;
    margin-bottom: 10px;
}

/* Error/Empty/Loading messages */
.error-message {
    color: #dc3545;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    padding: 10px;
    border-radius: 5px;
    margin-top: 15px;
}

.empty-message, .loading-message {
    padding: 15px;
    background-color: #f0f0f0;
    border-radius: 5px;
    color: #666;
    text-align: center;
}
.item-note {
    font-size: 0.9em;
    color: #6c757d;
    margin-bottom: 20px;
}


/* ==================================================== */
/* 2. Upload Form Styling */
/* ==================================================== */

.upload-apk-form-card {
    background-color: #f7f7f7; 
    padding: 20px;
    border-radius: 8px;
    border: 1px dashed #ccc; 
}

.upload-form-title {
    margin-top: 0;
    color: #555;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 20px;
}

.upload-input-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
}

.file-select-area {
    width: 100%;
}

.file-label {
    display: block;
    padding: 12px 15px;
    border: 2px solid #007bff;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    background-color: #e6f0ff;
    color: #007bff;
    transition: background-color 0.2s;
    overflow: hidden; 
    white-space: nowrap;
    text-overflow: ellipsis;
}

.file-label:hover {
    background-color: #d1e5ff;
}

.text-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1em;
    width: 100%;
    box-sizing: border-box;
}

.description-input {
    resize: vertical;
    min-height: 80px;
}

.upload-button {
    padding: 12px 25px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1em;
    font-weight: bold;
    transition: background-color 0.2s;
    width: 100%; 
}

.upload-button:hover:not(:disabled) {
    background-color: #1e7e34;
}

.upload-button:disabled {
    background-color: #90d39e;
    cursor: not-allowed;
}

/* Pastikan warna teks asal butang anda kontras dan jelas */
.upload-button {
    position: relative;
    overflow: hidden;
    color: #ffffff;
    font-weight: bold;
    transition: background 0.1s ease; /* Transisi laju supaya warna bergerak lancar */
    cursor: pointer;
}

/* Keadaan butang semasa proses memuat naik sedang berlangsung */
.upload-button:disabled.button-uploading {
    cursor: not-allowed;
    opacity: 1; /* Kekalkan kejelasan butang walaupun dalam mod disabled */
    box-shadow: none;
}


/* ==================================================== */
/* 3. APK Card Grid & Modal Styles */
/* ==================================================== */

.apk-selection-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-top: 20px;
    max-height: 400px; 
    overflow-y: auto; 
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 6px;
    justify-content: space-around; 
}

.apk-card {
    min-width: 200px; 
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s, border-color 0.2s;
    position: relative; 
    width: calc(33.333% - 10px); /* Default 3 columns */
}

.apk-card.selectable-card {
    cursor: pointer; 
}

.apk-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    border-color: #007bff; 
}

.apk-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.apk-version {
    font-size: 1.5em;
    font-weight: bold;
    color: #007bff;
}

/* ⭐️ ADDED: Filename and Description Styles ⭐️ */
.apk-file-name {
    font-size: 0.9em;
    color: #555;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; /* Truncate long filenames */
}

.apk-description {
    font-size: 0.85em;
    color: #777;
    margin-bottom: 15px;
    min-height: 30px;
    max-height: 40px;
    overflow: hidden;
    line-height: 1.3;
}
/* ⭐️ END ADDED ⭐️ */

.apk-date {
    font-size: 0.8em;
    color: #999;
}


/* --- Delete Icon Button --- */
.delete-icon-button {
    position: absolute;
    top: 5px; 
    right: 5px; 
    background: #dc3545; 
    color: white;
    border: none;
    border-radius: 50%; 
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s, background-color 0.2s;
    z-index: 10; 
    padding: 0;
}

.delete-icon-button:hover {
    background-color: #c82333; 
    opacity: 1;
}

.apk-card-actions {
    display: none; 
}


/* --- Modal Styles --- */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 25px;
    border-radius: 8px;
    max-width: 500px;
    width: 90%;
    position: relative;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.large-modal {
    max-width: 800px; 
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 1.5em;
    cursor: pointer;
}


/* Media Query for responsiveness */
@media (max-width: 992px) {
    .apk-card {
        /* 2 items per row */
        width: calc(50% - 7.5px); 
    }
    .large-modal {
        max-width: 90%;
    }
}

@media (max-width: 768px) {
    .apk-card {
        /* 1 item per row */
        width: 100%; 
        min-width: unset;
    }
    .modal-content {
        padding: 20px;
    }
    .upload-apk-form-card {
        padding: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/ApkManager.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,yDAAyD;AACzD,+CAA+C;AAC/C,yDAAyD;;AAEzD;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;;AAGA,yDAAyD;AACzD,2BAA2B;AAC3B,yDAAyD;;AAEzD;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,2DAA2D;AAC3D;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gCAAgC,EAAE,+CAA+C;IACjF,eAAe;AACnB;;AAEA,gEAAgE;AAChE;IACI,mBAAmB;IACnB,UAAU,EAAE,0DAA0D;IACtE,gBAAgB;AACpB;;;AAGA,yDAAyD;AACzD,oCAAoC;AACpC,yDAAyD;;AAEzD;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,6CAA6C;IAC7C,kBAAkB;IAClB,2BAA2B,EAAE,sBAAsB;AACvD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,iDAAiD;AACjD;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB,EAAE,4BAA4B;AACzD;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA,oBAAoB;;AAEpB;IACI,gBAAgB;IAChB,WAAW;AACf;;;AAGA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,+CAA+C;IAC/C,WAAW;IACX,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;;AAGA,yBAAyB;AACzB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;;AAGA,mCAAmC;AACnC;IACI;QACI,oBAAoB;QACpB,wBAAwB;IAC5B;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* ApkManager.css */\n\n/* ==================================================== */\n/* 1. Modal Container and Main Card Structure */\n/* ==================================================== */\n\n.main-content-card {\n    background-color: #ffffff;\n    padding: 30px; \n    border-radius: 12px;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15); \n}\n\n.list-title {\n    color: #333;\n    margin-top: 0;\n    margin-bottom: 10px;\n}\n\n/* Error/Empty/Loading messages */\n.error-message {\n    color: #dc3545;\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    padding: 10px;\n    border-radius: 5px;\n    margin-top: 15px;\n}\n\n.empty-message, .loading-message {\n    padding: 15px;\n    background-color: #f0f0f0;\n    border-radius: 5px;\n    color: #666;\n    text-align: center;\n}\n.item-note {\n    font-size: 0.9em;\n    color: #6c757d;\n    margin-bottom: 20px;\n}\n\n\n/* ==================================================== */\n/* 2. Upload Form Styling */\n/* ==================================================== */\n\n.upload-apk-form-card {\n    background-color: #f7f7f7; \n    padding: 20px;\n    border-radius: 8px;\n    border: 1px dashed #ccc; \n}\n\n.upload-form-title {\n    margin-top: 0;\n    color: #555;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 10px;\n    margin-bottom: 20px;\n}\n\n.upload-input-group {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.file-select-area {\n    width: 100%;\n}\n\n.file-label {\n    display: block;\n    padding: 12px 15px;\n    border: 2px solid #007bff;\n    border-radius: 4px;\n    cursor: pointer;\n    text-align: center;\n    background-color: #e6f0ff;\n    color: #007bff;\n    transition: background-color 0.2s;\n    overflow: hidden; \n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.file-label:hover {\n    background-color: #d1e5ff;\n}\n\n.text-input {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 1em;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.description-input {\n    resize: vertical;\n    min-height: 80px;\n}\n\n.upload-button {\n    padding: 12px 25px;\n    background-color: #28a745;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 1em;\n    font-weight: bold;\n    transition: background-color 0.2s;\n    width: 100%; \n}\n\n.upload-button:hover:not(:disabled) {\n    background-color: #1e7e34;\n}\n\n.upload-button:disabled {\n    background-color: #90d39e;\n    cursor: not-allowed;\n}\n\n/* Pastikan warna teks asal butang anda kontras dan jelas */\n.upload-button {\n    position: relative;\n    overflow: hidden;\n    color: #ffffff;\n    font-weight: bold;\n    transition: background 0.1s ease; /* Transisi laju supaya warna bergerak lancar */\n    cursor: pointer;\n}\n\n/* Keadaan butang semasa proses memuat naik sedang berlangsung */\n.upload-button:disabled.button-uploading {\n    cursor: not-allowed;\n    opacity: 1; /* Kekalkan kejelasan butang walaupun dalam mod disabled */\n    box-shadow: none;\n}\n\n\n/* ==================================================== */\n/* 3. APK Card Grid & Modal Styles */\n/* ==================================================== */\n\n.apk-selection-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n    margin-top: 20px;\n    max-height: 400px; \n    overflow-y: auto; \n    padding: 10px;\n    border: 1px solid #eee;\n    border-radius: 6px;\n    justify-content: space-around; \n}\n\n.apk-card {\n    min-width: 200px; \n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s, border-color 0.2s;\n    position: relative; \n    width: calc(33.333% - 10px); /* Default 3 columns */\n}\n\n.apk-card.selectable-card {\n    cursor: pointer; \n}\n\n.apk-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n    border-color: #007bff; \n}\n\n.apk-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n}\n\n.apk-version {\n    font-size: 1.5em;\n    font-weight: bold;\n    color: #007bff;\n}\n\n/* ⭐️ ADDED: Filename and Description Styles ⭐️ */\n.apk-file-name {\n    font-size: 0.9em;\n    color: #555;\n    margin-bottom: 8px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; /* Truncate long filenames */\n}\n\n.apk-description {\n    font-size: 0.85em;\n    color: #777;\n    margin-bottom: 15px;\n    min-height: 30px;\n    max-height: 40px;\n    overflow: hidden;\n    line-height: 1.3;\n}\n/* ⭐️ END ADDED ⭐️ */\n\n.apk-date {\n    font-size: 0.8em;\n    color: #999;\n}\n\n\n/* --- Delete Icon Button --- */\n.delete-icon-button {\n    position: absolute;\n    top: 5px; \n    right: 5px; \n    background: #dc3545; \n    color: white;\n    border: none;\n    border-radius: 50%; \n    width: 25px;\n    height: 25px;\n    line-height: 25px;\n    text-align: center;\n    font-size: 1.2em;\n    font-weight: bold;\n    cursor: pointer;\n    opacity: 0.8;\n    transition: opacity 0.2s, background-color 0.2s;\n    z-index: 10; \n    padding: 0;\n}\n\n.delete-icon-button:hover {\n    background-color: #c82333; \n    opacity: 1;\n}\n\n.apk-card-actions {\n    display: none; \n}\n\n\n/* --- Modal Styles --- */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    padding: 25px;\n    border-radius: 8px;\n    max-width: 500px;\n    width: 90%;\n    position: relative;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.large-modal {\n    max-width: 800px; \n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: none;\n    border: none;\n    font-size: 1.5em;\n    cursor: pointer;\n}\n\n\n/* Media Query for responsiveness */\n@media (max-width: 992px) {\n    .apk-card {\n        /* 2 items per row */\n        width: calc(50% - 7.5px); \n    }\n    .large-modal {\n        max-width: 90%;\n    }\n}\n\n@media (max-width: 768px) {\n    .apk-card {\n        /* 1 item per row */\n        width: 100%; \n        min-width: unset;\n    }\n    .modal-content {\n        padding: 20px;\n    }\n    .upload-apk-form-card {\n        padding: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
